jQuery(window).on("scroll", function() {
    var fromTop = jQuery(window).scrollTop();
    jQuery("body").toggleClass("sticky", (fromTop > 500));
});
jQuery('img.svg').each(function() {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

    }, 'xml');

});

jQuery(document).ready(function() {
    jQuery('.shopify-challenge__container ').addClass('col-xs-12');
});

jQuery(document).on('click', 'a[href^="#"]', function(event) {
  var target = jQuery(this).attr('href');
  var targetElement = jQuery(target);
  
  // Si el elemento objetivo es un modal, no hacer scroll, dejar que el modal se maneje
  if (targetElement.hasClass('modal') || targetElement.hasClass('popup__overlay')) {
    return;
  }
  
  // Si el elemento existe y no es un modal, hacer scroll
  if (targetElement.length) {
    event.preventDefault();
    jQuery('html, body').animate({
      scrollTop: targetElement.offset().top - 150
    }, 1500);
  }
});